import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";

import { PageHeader, Pagination } from "../../components";
import pages from "../../constants/pages";
import List from "./brand list components/List";
import { useAxios, useComponent } from "../../hooks";
import { PrimaryButton } from "../css components/Button";
import { Grid } from "@mui/material";

export default function BrandAgencyList() {
  const axios = useAxios();
  const navigate = useNavigate();
  const { loader } = useComponent();

  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState([]);
  const [page, setPage] = useState({
    page: 1,
    totalCount: 0,
    lastCount: 0,
    itemsPerPage: 10,
  });

  const { businessEntityID } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    setLoading(true);

    axios({
      url:
        "/brand?businessEntityId=" +
        businessEntityID +
        `&page=${page.page}&limit=${page.itemsPerPage}`,
    }).then((response) => {
      if (response.status) {
        if (response.data.parsedBrands?.length > 0) {
          setBrands(response.data.parsedBrands);
          setPage((prev) => ({
            ...prev,
            totalCount: response.data.totalCount,
            lastPage: response.data.parsedBrands?.length < 10,
          }));
        } else {
          setBrands([]);
        }
      }
      setLoading(false);
    });
  }, [axios, businessEntityID, loader, page.page, page.itemsPerPage]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      ...prev,
      page: step === "index" ? index : prev + (step === "next" ? 1 : -1),
    }));
  }

  return (
    <Fragment>
      <PageHeader
        pageName={"Brands"}
        pageHeader="A complete list of all registered brand profiles."
        buttons={[
          <PrimaryButton
            variant="contained"
            onClick={() =>
              navigate(
                pages.brandDetailCreateEmpty.route + "?newMultiBrand=" + true
              )
            }
          >
            Add Brand
          </PrimaryButton>,
        ]}
      />

      <List brands={brands} loading={loading} />

      {!!page.totalCount && (
        <Grid
          item
          container
          marginTop={"10px"}
          display={"flex"}
          justifyContent={"center"}
        >
          <Pagination
            count={Math.ceil(page.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
